import { useState, useEffect } from 'react'
import { api } from '../api/client.js'

export function useAuditLogActions() {
  const [actions, setActions] = useState<string[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function fetchActions() {
      try {
        setLoading(true)
        const response = await api.get<{ actions: string[] }>('/admin/compliance/audit-log/actions')
        setActions(response.actions)
        setError(null)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch actions')
      } finally {
        setLoading(false)
      }
    }

    void fetchActions()
  }, [])

  return { actions, loading, error }
}
